import { render, staticRenderFns } from "./CredentialView.vue?vue&type=template&id=13bf9518&scoped=true&"
import script from "./CredentialView.vue?vue&type=script&lang=js&"
export * from "./CredentialView.vue?vue&type=script&lang=js&"
import style0 from "./CredentialView.vue?vue&type=style&index=0&id=13bf9518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf9518",
  null
  
)

export default component.exports